import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api, { getAccessToken, setTokens, clearTokens } from '../services/api';
import { isDemoMode, exitDemoMode } from '../services/demo';

function encryptPassword(password) {
  return btoa(unescape(encodeURIComponent(password)));
}

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      login: async (email, password) => {
        const encrypted = encryptPassword(password);
        const res = await api.post('/auth/login', { email, password: encrypted });
        const data = res.data;
        setTokens(data.token, data.refreshToken || '');
        set({ token: data.token, isAuthenticated: true });
        await get().checkAuth();
        return get().user;
      },
      register: async (email, password, displayName, inviteToken) => {
        const encrypted = encryptPassword(password);
        const res = await api.post('/auth/register', { email, password: encrypted, displayName, inviteToken: inviteToken || null });
        return res.data;
      },
      logout: () => {
        clearTokens();
        if (isDemoMode()) exitDemoMode();
        set({ user: null, token: null, isAuthenticated: false });
      },
      checkAuth: async () => {
        try {
          const token = getAccessToken();
          if (!token) return false;
          const res = await api.get('/users/me');
          const u = res.data;
          set({
            user: {
              id: u.id,
              username: u.username,
              email: u.email,
              displayName: u.displayName,
              avatarUrl: u.avatarUrl,
              status: u.statusText || u.status,
              emailConfirmed: u.emailConfirmed,
              theme: u.theme || 'light',
              bgColor: u.bgColor,
              chatBgColor: u.chatBgColor,
              textColor: u.textColor,
              chatTextColor: u.chatTextColor,
              msgBgColor: u.msgBgColor,
              systemTextColor: u.systemTextColor,
              chatBgImage: u.chatBgImage,
              isAdmin: !!u.isAdmin,
              mustChangePassword: !!u.mustChangePassword,
            },
            token,
            isAuthenticated: true
          });
          return true;
        } catch (err) {
          if (err.response?.status === 401) {
            clearTokens();
            set({ user: null, token: null, isAuthenticated: false });
          }
          return false;
        }
      },
      updateUser: (data) => set((s) => ({ user: { ...s.user, ...data } })),
    }),
    { name: 'trandi-auth' }
  )
);
